import * as React from 'react';
import { Promo as PromoComponent } from '../../components/Promo';

interface IPromoProps {
  label?: string | null;
}

export function Promo({ label }: IPromoProps) {
  if (!label) {
    return null;
  }

  return <PromoComponent label={label} />;
}
